import React, {useEffect} from 'react';
import { withStyles } from "@material-ui/core/styles";
import __ from "lodash";
import moment from "moment";
import PropTypes from 'prop-types';
import { FixedSizeList } from 'react-window';
import { useQueryClient } from 'react-query';
import {Checkbox, Icon, ListItem, ListItemText} from "@material-ui/core";

import {useAirportFlights} from "../../../services/flights";


/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  root: {
    width: '50%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

const FlightListLookup = (props) => {
  const width = props.width || 200;
  const canEdit = props.canEdit;
  const airportCode = props.airportCode;
  const fromDate = props.fromDate;
  const airlineCode = props.airlineCode;
  const flightNo = props.flightNo;
  const orderLines = props.orderLines;
  const classes = props.classes;

  const queryClient = useQueryClient();
  const extraKeys = __.isEmpty(airlineCode) ? [airportCode, fromDate] : __.isEmpty(flightNo) ? [airportCode, fromDate, airlineCode] : [airportCode, fromDate, airlineCode, flightNo];
  const flightRecords = useAirportFlights({queryClient, useCache: false, extraKeys});

  let records = [];
  if (flightRecords.data) {
    flightRecords.data.forEach(record => {
      if (__.find(orderLines, {tripLegUuid: record.tripLegUuid}) === undefined)
        records.push(record);
    });
  }

  const initializeChecked = () => {
    return [];
  }

  const [checked, setChecked] = React.useState(null);

  if (records && records.length > 0 && checked === null) {
    setChecked(initializeChecked());
  }

  const handleToggle = (record) => () => {
    const currentIndex =  __.findIndex(checked, {tripLegUuid: record.tripLegUuid});
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(record);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    if (props.onChange)
      props.onChange(newChecked);

    setChecked(newChecked);
  };

  const renderRow = (props) => {
    const {index, style, isScrolling} = props;

    const record = records[index];
    const labelId = `checkbox-list-label-${record.airlineCode}${record.flightNumber}`;
    const key = `${record.airlineCode}_${record.flightNo}_${record.flightDate}`;

    return (
      <ListItem key={key} style={style} dense disablePadding button disabled={!canEdit} onClick={handleToggle(record)}>
        <Checkbox
          style={{padding:3}}
          edge="start"
          checked={checked && __.findIndex(checked, {airlineCode: record.airlineCode, flightNo: record.flightNo, flightDate: record.flightDate}) !== -1}
          tabIndex={-1}
          disableRipple
          inputProps={{ 'aria-labelledby': labelId }}
          //color={standAloneMode ? 'primary' : undefined}
        />
        <div style={{fontSize: "12px"}}>
          {`${record.airlineCode}${record.flightNo} - ${record.originAirportCode}`}
          <Icon className={classes.aircraftSeparator}>local_airport</Icon>
          {`${record.destinationAirportCode} - ${moment(record.flightDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}`}
        </div>
      </ListItem>
    );
  }

  renderRow.propTypes = {
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
  };

  return (
    records && records.length > 0
      ?
        <FixedSizeList
          height={550}
          width={width}
          itemSize={38}
          itemCount={records.length}
          useIsScrolling
        >
          {renderRow}
        </FixedSizeList>
      :
        <></>
  );
}

export default withStyles(styles) (FlightListLookup);
